module.exports = __webpack_public_path__ + "static/media/Apple Watch 38mm Black Steel + Black Open.a2782b6c.png";